<template>
  <div>
    <h3 class="page-title">素材管理</h3>
    <h4 class="breadcrumb-c">
      <router-link
        :to="{
          name: 'material',
          query: {
            type: 4
          }
        }"
        class="back-btn"
      >
        <i class="fa fa-angle-left"></i> 语音 </router-link
      >/ 新建语音
    </h4>
    <form class="form-horizontal form form-create" role="form">
      <div class="form-body">
        <div class="form-group">
          <label class="control-label col-sm-1" style="padding-right:0;">
            <span class="required"> * </span>上传音频</label
          >
          <div class="col-sm-8">
            <p class="form-control-static" style="color:#888;">
              格式支持mp3、wma、wav、amr，文件大小不超过10M，建议时长不超过15分钟
            </p>
            <c-file-upload :config.sync="content"></c-file-upload>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-1 control-label">
            <span class="required"> * </span>标题</label
          >
          <div class="col-sm-8">
            <p class="form-control-static" style="color:#888;">
              该标题将会在AR扫描界面显示
            </p>
            <input
              class="form-control"
              v-model="title"
              maxlength="24"
              v-maxlength
            />
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-1">
            <span class="required">*</span>封面
            <!--<span class="required"> * </span>-->
          </label>
          <div class="col-sm-8">
            <c-file-upload :config.sync="cover"></c-file-upload>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-1 control-label">分组</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="gid">
              <option value="ungroup">未分组</option>
              <template v-for="g in groups">
                <option :value="g.objectId">{{ g.title }}</option>
              </template>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label class="col-sm-1 control-label" style="vertical-align:top"
            >简介</label
          >
          <div class="col-sm-8">
            <textarea
              class="form-control"
              rows="3"
              v-model="about"
              maxlength="1000"
              v-maxlength
            ></textarea>
          </div>
        </div>
        <div class="form-group">
          <!--<label class="col-sm-3 control-label"></label>-->
          <div class="col-sm-12" style="text-align: center">
            <p class="form-control-static" style="color:#888;">
              不得上传未经授权的他人作品，以及色情、反动等违法视频。
            </p>
          </div>
        </div>
        <div class="form-group">
          <!--<label class="col-sm-3 control-label"></label>-->
          <div class="col-sm-12">
            <div class="checkbox-list" style="text-align: center">
              <label class="checkbox-inline">
                <!-- <div class="checker">
                  <span class="checked"
                    ><input type="checkbox" data-enpassusermodified="yes"
                  /></span>
                </div> -->
                <!-- <input
                  type="checkbox"
                  v-model="agreeRule"
                  v-mcheck
                /> -->
                我已同意并阅读
                <a
                  href="/web-mgr/media/agreement"
                  target="_blank"
                  style="color:#4a90e2"
                  >《视网么音视频上传规则》</a
                >
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-actions" style="margin-left: 20px;margin-right: 20px;">
        <div class="row">
          <div class="col-sm-12" style="text-align:center;">
            <button type="button" class="btn m-green" @click="submit()">
              保存
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script type="text/javascript">
import $ from 'jquery'

import { mapState, mapActions } from 'vuex'

import cFileUpload from '../../components/fileupload'

export default {
  data() {
    return {
      title: '',
      about: '',
      agreeRule: true,
      gid: localStorage.getItem('group') || 'ungroup',
      content: {
        type: 'audio',
        accept: '.mp3,.wma,.wav,.amr',
        name: 'content',
        fileName: null,
        file: null
      },
      cover: {
        nolocal: true,
        space: 'image',
        name: 'file',
        type: 'image',
        accept: '.jpg,.png,.jpeg',
        fileName: null,
        file: null,
        imgId: null
      }
    }
  },
  components: {
    cFileUpload
  },
  computed: mapState(['groups']),
  watch: {
    'content.fileName'(val) {
      this.title = val
      if (val) {
        let idx = val.lastIndexOf('.')

        if (idx > 0) {
          this.title = val.substr(0, idx)
        }
      }

      if (this.title && this.title.length > 10) {
        this.title = this.title.substr(0, 10)
      }
    }
  },
  methods: {
    ...mapActions([
      'toast',
      'showAlert',
      'showConfirm',
      'showLoading',
      'hideLoading',
      'showPlayer',
      'hidePlayer',
      'saveVideoTime'
    ]),
    submit() {
      let self = this

      // if (!this.agreeRule) {
      //   this.showAlert('请同意我们的上传规则。');
      //   return;
      // }

      if (!this.cover.imgId) {
        this.showAlert('请上传封面')
        return
      }

      this.showLoading('提交中，请稍后。。。')

      $.ajaxFileUpload({
        url: '/api/web/material/audio/add',
        secureuri: false,
        // timeout: 1000 * 60,
        fileElementId: $(self.content.file),
        data: {
          title: self.title,
          gid: self.gid,
          coverId: self.cover.imgId,
          about: self.about
        },
        dataType: 'json',
        success: function(data, status) {
          self.hideLoading()
          if (data.code == 200) {
            if (data.data && data.data.content && data.data.content.url) {
              self.saveVideoTime({
                url: data.data.content.url,
                id: data.data.objectId,
                type: 'audio'
              })
            }
            self.toast('恭喜您，添加成功！')
            self.back()
          } else {
            self.showAlert((data && data.message) || '操作失败，请稍后再试！')
            self.$router.push(0)
          }
        },
        error: function(data, status, e) {
          self.hideLoading()
          self.showAlert((data && data.message) || '操作失败，请稍后再试！')
          self.$router.push(0)
          // self.back();
        }
      })
    },
    back() {
      //this.$emit('voice-create-complete');
      this.$router.push({
        name: 'material',
        query: {
          type: 4
        },
        replace: true
      })
    }
  }
}
</script>
